import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { getTaxiRouteDirectory } from '../data/taxiRouteDirectory';
import '../styles/PopularTaxiRoutes.css';

/**
 * Customer-facing city names for the 38 Tamil Nadu locations.
 * Every href is an existing landing page. No new URLs are introduced.
 * The first 12 are the initial homepage set. The rest appear after the routes button.
 */
const CITIES = [
  { name: 'Chennai', href: '/chennai-taxi' },
  { name: 'Coimbatore', href: '/coimbatore-taxi' },
  { name: 'Madurai', href: '/madurai-taxi' },
  { name: 'Tiruchirappalli', href: '/trichy-taxi' },
  { name: 'Salem', href: '/salem-taxi' },
  { name: 'Tiruppur', href: '/tiruppur-to-coimbatore' },
  { name: 'Erode', href: '/erode-taxi' },
  { name: 'Vellore', href: '/coimbatore-to-vellore-taxi' },
  { name: 'Thanjavur', href: '/coimbatore-to-thanjavur-taxi' },
  { name: 'Tirunelveli', href: '/coimbatore-to-thirunelveli-taxi' },
  { name: 'Kanniyakumari', href: '/coimbatore-to-kaniyakumari-taxi' },
  { name: 'Karur', href: '/karur-to-coimbatore' },
  { name: 'Ariyalur', href: '/ariyalur-taxi' },
  { name: 'Chengalpattu', href: '/chengalpattu-taxi' },
  { name: 'Cuddalore', href: '/coimbatore-to-cuddalore-taxi' },
  { name: 'Dharmapuri', href: '/dharmapuri-taxi' },
  { name: 'Dindigul', href: '/dindigul-taxi' },
  { name: 'Kallakurichi', href: '/kallakurichi-taxi' },
  { name: 'Kancheepuram', href: '/kancheepuram-taxi' },
  { name: 'Krishnagiri', href: '/coimbatore-to-hosur-taxi' },
  { name: 'Mayiladuthurai', href: '/mayiladuthurai-taxi' },
  { name: 'Nagapattinam', href: '/coimbatore-to-nagapatinam-taxi' },
  { name: 'Namakkal', href: '/namakkal-taxi' },
  { name: 'Nilgiris', href: '/coimbatore-to-ooty' },
  { name: 'Perambalur', href: '/perambalur-taxi' },
  { name: 'Pudukkottai', href: '/pudukkottai-taxi' },
  { name: 'Ramanathapuram', href: '/coimbatore-to-ramanathapuram-taxi' },
  { name: 'Ranipet', href: '/ranipet-taxi' },
  { name: 'Sivaganga', href: '/sivaganga-taxi' },
  { name: 'Tenkasi', href: '/coimbatore-to-tenkasi-taxi' },
  { name: 'Theni', href: '/theni-taxi' },
  { name: 'Thoothukudi', href: '/coimbatore-to-thoothukudi-taxi' },
  { name: 'Tirupathur', href: '/coimbatore-to-ambur-taxi' },
  { name: 'Tiruvallur', href: '/tiruvallur-taxi' },
  { name: 'Tiruvannamalai', href: '/coimbatore-to-tiruvannamalai-taxi' },
  { name: 'Tiruvarur', href: '/coimbatore-to-thiruvarur-taxi' },
  { name: 'Viluppuram', href: '/coimbatore-to-villupuram-taxi' },
  { name: 'Virudhunagar', href: '/virudhunagar-taxi' },
];

const INITIAL_COUNT = 12;

const existingRoutes = () => {
  const seen = new Set();
  const routes = [];
  getTaxiRouteDirectory().groups.forEach((group) => {
    group.routes.forEach((route) => {
      if (!route.path || seen.has(route.path)) return;
      seen.add(route.path);
      routes.push(route);
    });
  });
  return routes;
};

const PopularTaxiRoutes = () => {
  const [expanded, setExpanded] = useState(false);
  const [showAllCities, setShowAllCities] = useState(false);
  const routes = useMemo(() => existingRoutes(), []);
  const visibleCities = showAllCities ? CITIES : CITIES.slice(0, INITIAL_COUNT);

  return (
    <section className="explore-cities" aria-labelledby="explore-cities-heading">
      <div className="container">
        <header className="explore-cities-header">
          <h2 id="explore-cities-heading">Explore All Cities</h2>
          <p>
            Discover taxi routes across Tamil Nadu. Choose a city to explore available taxi routes with EasyDropTaxi.
          </p>
        </header>

        <ul className="explore-cities-grid">
          {visibleCities.map((city) => (
            <li key={city.href}>
              <Link className="explore-city-card" to={city.href}>
                <i className="fa fa-map-marker" aria-hidden="true"></i>
                <span>{city.name}</span>
                <i className="fa fa-angle-right" aria-hidden="true"></i>
              </Link>
            </li>
          ))}
        </ul>

        {expanded ? (
          <ul className="explore-cities-grid explore-route-grid">
            {routes.map((route) => (
              <li key={route.path}>
                <Link className="explore-city-card" to={route.path}>
                  <i className="fa fa-road" aria-hidden="true"></i>
                  <span>{route.origin} to {route.destination}</span>
                  <i className="fa fa-angle-right" aria-hidden="true"></i>
                </Link>
              </li>
            ))}
          </ul>
        ) : null}

        <div className="explore-cities-actions">
          <button
            type="button"
            className="explore-cities-toggle"
            aria-expanded={showAllCities}
            onClick={() => setShowAllCities(true)}
          >
            {CITIES.length} Routes
          </button>
          <button
            type="button"
            className="explore-cities-toggle"
            aria-expanded={expanded}
            onClick={() => setExpanded((open) => !open)}
          >
            {expanded ? 'Show Less' : 'View All Taxi Routes'}
          </button>
        </div>
      </div>
    </section>
  );
};

export default PopularTaxiRoutes;
